import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=0c4ea9de&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=ts&"
export * from "./resetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=0c4ea9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ea9de",
  null
  
)

export default component.exports